import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { firstError, findError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import { updateActiveVocabularyProperties } from '../actions';
import { vocabularyFieldLengths } from '../constants';

const VocabularyTextForm = ({
  submitForm,
  updateErrors,
  updateProperties,
  updateStatus,
  value,
}) => {
  const intl = useIntl();
  const valueError = findError(updateErrors, 'vocabulary', [fields.VALUE]);
  return (
    <div className="content">
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(updateErrors) !== null}>
        <FormValidationError error={valueError} htmlFor="vocabulary_value" position="bottom left">
          <Input
            id="vocabulary_value"
            error={valueError}
            autoFocus
            disabled={updateStatus === states.PENDING}
            type="custom"
            size="large"
            placeholder={intl.formatMessage({ id: 'save.vocabulary.value.placeholder' })}
            value={value}
            maxLength={vocabularyFieldLengths.value}
            onChange={(e) => updateProperties({ value: e.target.value })}
          />
        </FormValidationError>
      </Form>
    </div>
  );
};

const mapStateToProps = ({
  vocabularies: { activeVocabulary: { updateErrors, updateStatus, value } },
}) => ({ updateErrors, updateStatus, value });

const mapDispatchToProps = {
  updateProperties: updateActiveVocabularyProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyTextForm);
